import { styled, typography } from '@pulse-web-ui/theme';

import { StatusType } from './status.types';

export const StatusWrapper = styled.div<{ $type: StatusType }>`
  ${typography.regular12};
  display: inline-block;
  background-color: ${({ theme, $type }) => {
    if ($type === StatusType.ERROR) {
      return theme.colors.accent.error.clarified;
    } else if ($type === StatusType.WARNING) {
      return theme.colors.surface.warning['success-light'];
    } else if ($type === StatusType.SUCCESS) {
      return theme.colors.surface.success['success-light'];
    } else if ($type === StatusType.INFO) {
      return theme.colors.surface.background;
    } else {
      return theme.colors.surface.success['success-light'];
    }
  }};
  color: ${({ theme, $type }) => {
    if ($type === StatusType.ERROR) {
      return theme.colors.text.error;
    } else if ($type === StatusType.WARNING) {
      return theme.colors.text.warning;
    } else if ($type === StatusType.SUCCESS) {
      return theme.colors.text.success;
    } else if ($type === StatusType.INFO) {
      return theme.colors.text.secondary;
    } else {
      return theme.colors.text.success;
    }
  }};
  border-radius: 16px;
  padding: 0 8px;
`;
